
import React from 'react';
import { SubscriptionCard } from './SubscriptionCard';
import { EmptySubscriptions } from './EmptySubscriptions';
import { Subscription } from '@/services/types/subscriptionTypes';
import { Skeleton } from '@/components/ui/skeleton';
import { useIsMobile } from '@/hooks/use-mobile';

interface SubscriptionsListProps {
  subscriptions: Subscription[];
  onStatusChange: (subscriptionId: string, status: 'active' | 'paused' | 'cancelled') => Promise<void>;
  actionLoading: string | null;
  loading?: boolean;
}

export const SubscriptionsList = ({ 
  subscriptions, 
  onStatusChange,
  actionLoading,
  loading = false
}: SubscriptionsListProps) => {
  const isMobile = useIsMobile();
  
  console.log('Рендер SubscriptionsList:', { 
    количествоПодписок: subscriptions?.length,
    подписки: subscriptions,
    loading,
    isMobile
  });
  
  // Фильтруем подписки, скрывая отмененные (cancelled)
  const filteredSubscriptions = subscriptions.filter(sub => sub.status !== 'cancelled');
  
  if (loading) {
    return (
      <div className={`grid grid-cols-1 ${isMobile ? '' : 'md:grid-cols-2 lg:grid-cols-3'} gap-${isMobile ? '3' : '4'}`}>
        {Array(isMobile ? 2 : 3).fill(0).map((_, i) => (
          <Skeleton key={i} className={`w-full h-${isMobile ? '40' : '48'} rounded-lg`} />
        ))}
      </div>
    );
  }
  
  // Проверяем наличие подписок после фильтрации
  if (!filteredSubscriptions || filteredSubscriptions.length === 0) {
    console.log('Нет активных подписок для отображения');
    return <EmptySubscriptions />;
  }

  return (
    <div className={`grid grid-cols-1 ${isMobile ? '' : 'md:grid-cols-2 lg:grid-cols-3'} gap-${isMobile ? '3' : '4'}`}>
      {filteredSubscriptions.map((subscription) => (
        <SubscriptionCard 
          key={subscription.id} 
          subscription={subscription}
          onStatusChange={onStatusChange}
          actionLoading={actionLoading}
        />
      ))}
    </div>
  );
};
